<template>
  <div v-if="account">
    <UserSummaryPopover v-if="!disablePopover" :account="account">
      <v-chip
        v-bind="vuetifyProps"
        class="ps-0 chip-avatar"
        data-private
        pill
        :ripple="ripple"
        :color="backgroundColor"
        :text-color="textColor"
        :small="small"
        :style="borderStyle"
        @click:close="$emit('click:close')"
        @click="$emit('click')"
      >
        <UserAvatar
          class="me-2"
          :class="{ caption: xsmall }"
          :account="account"
          :fontSize="avatarFontSize"
          :imageSize="IMAGE_SIZES.MINI"
          :size="avatarSize"
        />
        {{ getShortenedName(account) }}
      </v-chip>
    </UserSummaryPopover>

    <div v-else>
      <v-chip
        v-bind="vuetifyProps"
        class="ps-0 chip-avatar"
        data-private
        pill
        :ripple="ripple"
        :color="backgroundColor"
        :text-color="textColor"
        :small="small"
        :style="borderStyle"
        @click:close="$emit('click:close')"
        @click="$emit('click')"
      >
        <UserAvatar
          class="me-2"
          :class="{ caption: xsmall }"
          :account="account"
          :fontSize="avatarFontSize"
          :imageSize="IMAGE_SIZES.MINI"
          :size="avatarSize"
        />
        {{ getShortenedName(account) }}
      </v-chip>
    </div>
  </div>
  <div v-else class="blue-grey--tex text-start">-</div>
</template>

<script>
import userMixin from '@/mixins/userMixin.vue'

import UserAvatar from '@/components/UserAvatar.vue'
import UserSummaryPopover from '@/components/UserSummaryPopover.vue'
import { IMAGE_SIZES } from 'rever-media-sdk'

export default {
  name: 'ChipAvatar',

  components: {
    UserAvatar,
    UserSummaryPopover,
  },

  mixins: [userMixin],

  props: {
    small: {
      type: Boolean,
      default: false,
    },
    account: {
      type: Object,
      required: false,
    },
    vuetifyProps: {
      type: Object,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'white',
    },
    borderColor: {
      type: String,
      required: false,
    },
    textColor: {
      type: String,
      required: false,
      default: 'blue-grey darken-2',
    },
    xsmall: {
      type: Boolean,
      default: false,
    },
    disablePopover: {
      type: Boolean,
      default: false,
    },
    hideBorder: {
      type: Boolean,
      default: false,
    },
    ripple: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      IMAGE_SIZES,
    }
  },

  computed: {
    defaultBorderColor() {
      return this.$styleVariables?.colorBlueGreyLighten2
    },
    avatarSize() {
      if (this.small) return '22px'
      if (this.xsmall) return '18px'
      return '32px'
    },
    avatarFontSize() {
      if (this.xsmall) return '8px'
      return '10px'
    },
    borderStyle() {
      return this.hideBorder
        ? null
        : `border: 1px solid ${this.borderColor ||
            this.defaultBorderColor} !important;`
    },
  },
}
</script>

<style lang="scss" scoped>
.chip-avatar {
  cursor: default;
}
</style>
